export default __webpack_public_path__ + "static/media/Shemmu.8bdcfb39.jpg";